module.exports = __webpack_public_path__ + "img/jefe_almacen_02.2ece9ce8.jpg";